export const SALARY_SETTINGS_LABEL = 'Настройки зарплаты';
